import * as React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Management from '../layouts/management';
import ManagementrLogin from '../pages/auth/login/management';
import NotFound from '../pages/auth/NotFound';
import Websites from '../pages/web-platform/websites/containers/websites';
import Pages from '../pages/web-platform/pages/containers/pages';
import Layouts from '../pages/web-platform/layouts/containers/layouts';
import Layout from '../pages/web-platform/layouts/containers/layout';
import Cards from '../pages/web-platform/cards/containers/cards';
import Website from '../pages/web-platform/websites/containers/website';
import WebsitePage from '../pages/web-platform/websites/containers/website-page';
import WebsiteLayout from '../pages/web-platform/websites/containers/website-layout';
import Tenants from '../pages/platform-management/tenants/containers/tenants';
import Card from '../pages/web-platform/cards/containers/card';
import TenantWebsite from '../pages/web-platform/tenant-websites/containers/tenant-website';
import Page from '../pages/web-platform/pages/containers/page';
import PageLayout from '../pages/web-platform/pages/containers/page-layout';
// import WebsiteCard from '../pages/web-platform/websites/containers/website-card';
import TenantWebsites from '../pages/web-platform/tenant-websites/containers/tenant-websites';
import PageCard from '../pages/web-platform/pages/containers/page-card';
import LayoutCard from '../pages/web-platform/layouts/containers/layout-card';
import WebsiteCard from '../pages/web-platform/websites/containers/website-card';
import TenantWebsiteCard from '../pages/web-platform/tenant-websites/containers/tenant-website-card';
import WorkInProgress from '../pages/auth/WorkInProgress';
import ManagementProfile from '../pages/web-platform/profile';
import ManagementHelpCenter from '../pages/web-platform/helpcenter';
import ManagementAddressBook from '../pages/web-platform/addressbook';
import CSGPortalLogin from '../pages/auth/login/csg-portal';
import { CSGHome } from '../pages/csg-portal';
import GuestLayout from '../layouts/guest';
import CSGPortalLayout from '../layouts/csg-portal';
import CSGPortalProfile from '../pages/csg-portal/profile';
import { GuestHome } from '../pages/guest';
import Organizations from '../pages/csg-portal/organizations';
import CSGPortalHelpCenter from '../pages/csg-portal/helpcenter';
import CSGPortalAddressBook from '../pages/csg-portal/addressbook';
import NexusLogin from '../pages/auth/login/nexus';
import NexusLayout from '../layouts/nexus';
import { NexusHome } from '../pages/nexus';
import NexusProfile from '../pages/nexus/profile';
import NexusHelpCenter from '../pages/nexus/helpcenter';
import NexusAddressBook from '../pages/nexus/addressbook';
import { ServicePINContainer } from '../common/components/pin/service-pin';
import { ManagementPINContainer } from '../common/components/pin/management-pin';
import ManagementnexusARecords from '../pages/nexus-management/nexus-a-record/containers/nexus-a-records';
import ManagementNexusARecordType from '../pages/nexus-management/nexus-a-record-types/containers/nexus-a-record-type';
import ManagementNexusARecordTypes from '../pages/nexus-management/nexus-a-record-types/containers/nexus-a-record-types';
import ManagementnexusARecordTypes from '../pages/nexus-management/nexus-a-record-types/containers/nexus-a-record-types';
import ManagementNexusARecord from '../pages/nexus-management/nexus-a-record/containers/nexus-a-record';
import Businesses from '../pages/csg-portal/platform-management/businesses/containers/businesses';
import BusinessUsers from '../pages/csg-portal/platform-management/business-users/containers/business-users';
import ProjectsContainer from '../pages/csg-portal/service/psa/projects/containers/projects';
import ServiceRequestsContainer from '../pages/csg-portal/service/cma/service-requests/containers/service-requests';
import ManagementTickets from '../pages/csg-portal/service/cma/tickets/containers/tickets';
import ManagementTicket from '../pages/csg-portal/service/cma/tickets/containers/ticket';
import ProjectContainer from '../pages/csg-portal/service/psa/projects/containers/project';
import EsbAuditLogs from '../pages/csg-portal/system/esb-audit-log/containers/esb-audit-logs';
import ManagementNexusZones from '../pages/nexus-management/nexus-zone/containers/nexus-zones';
import ManagementNexusZone from '../pages/nexus-management/nexus-zone/containers/nexus-zone';
import ManagementNexusNodes from '../pages/nexus-management/nexus-node/containers/nexus-nodes';
import ManagementNexusNode from '../pages/nexus-management/nexus-node/containers/nexus-node';







export default function AppRouter() {
	return (
		<Routes>

			<Route path="/" element={<GuestLayout />} >
				<Route path="" element={<GuestHome />} />
				<Route path="management/auth/login/pin" element={<ManagementPINContainer />} />
				<Route path="service/auth/login/pin" element={<ServicePINContainer />} />
			</Route>
			<Route path="/web-platform/*" element={<GuestLayout />} >
				<Route path="" element={<ManagementrLogin />} />
				<Route path="auth/login" element={<ManagementrLogin />} />
			</Route>
			<Route path="web-platform/*" element={<Management />} >

				<Route path="websites" element={<Websites />} />
				<Route path="websites/platform-website/:id" element={<Website />} />
				<Route path="websites/platform-website/:websiteId/platform-website-page/:id" element={<WebsitePage />} />
				<Route path="websites/platform-website/:websiteId/platform-website-page/:pageId/platform-website-layout/:id" element={<WebsiteLayout />} />
				<Route path="websites/platform-website/:websiteId/platform-website-page/:pageId/platform-website-layout/:layoutId/platform-website-layout-card/:id" element={<WebsiteCard />} />
				<Route path="pages" element={<Pages />} />
				<Route path="pages/platform-website-page/:id" element={<Page />} />
				<Route path="pages/platform-website-page/:pageId/platform-website-layout/:id" element={<PageLayout />} />
				<Route path="pages/platform-website-page/:pageId/platform-website-layout/:layoutId/platform-website-layout-card/:id" element={<PageCard />} />
				<Route path="layouts" element={<Layouts />} />
				<Route path="layouts/platform-website-layout/:id" element={<Layout />} />
				<Route path="layouts/platform-website-layout/:layoutId/platform-website-layout-card/:id" element={<LayoutCard />} />
				<Route path="cards" element={<Cards />} />
				<Route path="cards/:id" element={<Card />} />
				<Route path="card-types" element={< WorkInProgress />} />
				<Route path="platform-management/tenants" element={<Tenants />} />
				<Route path="platform-management/tenants/:id" element={<TenantWebsites />} />
				<Route path="platform-management/tenants/:tenantId/:id" element={<TenantWebsite />} />
				<Route path="platform-management/tenants/:tenantId/:platformWebSiteId/:id" element={<TenantWebsiteCard />} />
				<Route path="profile" element={<ManagementProfile />} />
				<Route path="helpcenter" element={<ManagementHelpCenter />} />
				<Route path="address" element={<ManagementAddressBook />} />
			</Route>

			<Route path="csg-portal/*" element={<GuestLayout />} >
				<Route path="" element={<CSGPortalLogin />} />
				<Route path="auth/login" element={<CSGPortalLogin />} />
			</Route>


			<Route path="csg-portal/*" element={<CSGPortalLayout />} >
				{/* <Route path="service/auth/login/pin" element={<ServicePINContainer />} /> */}
				{/* <Route path="management/auth/login/pin" element={<ManagementPINContainer />} /> */}
				<Route path="organizations" element={<Organizations />} />
				<Route path="platform-management" element={<Organizations />} />
				<Route path="platform-management/businesses" element={<Businesses />} />
				<Route path="platform-management/business-users" element={<BusinessUsers />} />
				<Route path="service/psa/projects" element={<ProjectsContainer />} />
				<Route path="service/psa/projects/:id" element={<ProjectContainer />} />
				<Route path="service/cma/service-requests" element={<ServiceRequestsContainer />} />
				<Route path="service/cma/tickets" element={<ManagementTickets />} />
				<Route path="service/cma/tickets/:id" element={<ManagementTicket />} />
				<Route path="profile" element={<CSGPortalProfile />} />
				<Route path="helpcenter" element={<CSGPortalHelpCenter />} />
				<Route path="address" element={<CSGPortalAddressBook />} />
				<Route path="system/esb-audit-log" element={<EsbAuditLogs />} />

			</Route>

			<Route path="nexus/*" element={<GuestLayout />} >
				<Route path="" element={<NexusLogin />} />
				<Route path="auth/login" element={<NexusLogin />} />
			</Route>
			<Route path="nexus/*" element={<NexusLayout />} >
				<Route path="ddns/eAdvisor/dashboards" element={<WorkInProgress />} />
				<Route path="ddns/eAdvisor/reports" element={<NexusHome />} />
				<Route path="ddns/sources/pops" element={<WorkInProgress />} />
				<Route path="ddns/sources/gateways" element={<NexusHome />} />
				<Route path="ddns/sources/tenants" element={<NexusHome />} />
				<Route path="ddns/sources/dbnps" element={<NexusHome />} />
				<Route path="ddns/sources/websites" element={<NexusHome />} />
				<Route path="ddns/sources/webpages" element={<NexusHome />} />
				<Route path="ddns/sources/users" element={<NexusHome />} />
				<Route path="ddns/records/arecords" element={<NexusHome />} />
				<Route path="ddns/records/cname" element={<NexusHome />} />
				<Route path="ddns/records/mx-records" element={<NexusHome />} />
				<Route path="ddns/records/txt-records" element={<NexusHome />} />
				<Route path="ddns/records/srv-records" element={<NexusHome />} />
				<Route path="ddns/records/ptr-records" element={<NexusHome />} />
				<Route path="ddns/records/dnssec" element={<NexusHome />} />
				<Route path="nexus-management/nexus-a-record-types" element={<ManagementNexusARecordTypes />} />
				<Route path="nexus-management/nexus-a-record-types/:id" element={<ManagementNexusARecordType />} />
				<Route path="nexus-management/nexus-a-records" element={<ManagementnexusARecords />} />
				<Route path="nexus-management/nexus-a-records/:id" element={<ManagementNexusARecord />} />
				<Route path="nexus-management/nexus-zone" element={<ManagementNexusZones />} />
				<Route path="nexus-management/nexus-zone/:id" element={<ManagementNexusZone />} />
				<Route path="nexus-management/nexus-node" element={<ManagementNexusNodes />} />
				<Route path="nexus-management/nexus-node/:id" element={<ManagementNexusNode />} />
				<Route path="profile" element={<NexusProfile />} />
				<Route path="helpcenter" element={<NexusHelpCenter />} />
				<Route path="address" element={<NexusAddressBook />} />
			</Route>



			<Route path="/auth/notfound" element={< NotFound />} />
			<Route path="/*" element={< Navigate to="/auth/notfound" replace={true} />} />
		</Routes>
	);
}
